import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PrivyProvider } from '@privy-io/react-auth';

// For development only - a placeholder project ID
// In production, you would need a real WalletConnect project ID
const WALLET_CONNECT_PROJECT_ID = "c8628eaf848a80b7d94bb85bcb27fdf0";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PrivyProvider
      appId="cm923qqyq0173lb0npocifqiy"
      config={{
        loginMethods: ['email', 'wallet'],
        appearance: {
          theme: 'light',
          accentColor: '#239063',
          showWalletLoginFirst: false
        },
        embeddedWallets: {
          noPromptOnSignature: true,
          createOnLogin: true
        },
        walletConnectProjectId: WALLET_CONNECT_PROJECT_ID,
        defaultWalletConnectorName: 'metamask',
        walletConnectors: [
          { name: 'metamask' }
        ]
      }}
    >
      <App />
    </PrivyProvider>
  </React.StrictMode>
);

reportWebVitals();
